import { createVNode as o, mergeProps as e } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MailConfigFilledStandard.js";
import n from "../components/PfIcon.js";
const r = (t, a) => {
  const i = {
    ...t,
    ...a.attrs
  };
  return o(n, e(i, {
    icon: l
  }), null);
};
r.displayName = "MailConfigFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
